import { createFileRoute } from '@tanstack/react-router'
import { HomeAssignmentsPage } from '@/components/infoPages/HomeAssignmentsPage'
import { withPublicPageSeo } from '@/modules/seo'

const HomeAssignmentsPageWithSeo = withPublicPageSeo(
  'takeHomeAssignments',
  HomeAssignmentsPage
)

export const Route = createFileRoute('/take-home-assignments')({
  component: HomeAssignmentsPageWithSeo,
})
